import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDiscordServerMutationVariables = Types.Exact<{
  input: Types.CreateDiscordServerInput;
}>;

export type CreateDiscordServerMutation = {
  __typename?: 'Mutation';
  createDiscordServer: {
    __typename?: 'DiscordServer';
    id: any;
    name: string;
    createdAt: any;
    owner?:
      | { __typename?: 'Team'; id: any; name: string }
      | { __typename?: 'User'; id: any; email: string }
      | null;
  };
};

export const CreateDiscordServerDocument = gql`
  mutation CreateDiscordServer($input: CreateDiscordServerInput!) {
    createDiscordServer(input: $input) {
      id
      owner {
        ... on User {
          id
          email
        }
        ... on Team {
          id
          name
        }
      }
      name
      createdAt
    }
  }
`;
export type CreateDiscordServerMutationFn = Apollo.MutationFunction<
  CreateDiscordServerMutation,
  CreateDiscordServerMutationVariables
>;

/**
 * __useCreateDiscordServerMutation__
 *
 * To run a mutation, you first call `useCreateDiscordServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscordServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscordServerMutation, { data, loading, error }] = useCreateDiscordServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscordServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscordServerMutation,
    CreateDiscordServerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDiscordServerMutation,
    CreateDiscordServerMutationVariables
  >(CreateDiscordServerDocument, options);
}
export type CreateDiscordServerMutationHookResult = ReturnType<
  typeof useCreateDiscordServerMutation
>;
export type CreateDiscordServerMutationResult =
  Apollo.MutationResult<CreateDiscordServerMutation>;
export type CreateDiscordServerMutationOptions = Apollo.BaseMutationOptions<
  CreateDiscordServerMutation,
  CreateDiscordServerMutationVariables
>;
